import { EAuthSocialErrorCode } from 'entities/Auth/Auth.models';

const useSocialConnectError = (): EAuthSocialErrorCode | null => {
  const code = new URLSearchParams(window.location.search).get('errorCode') ?? '';

  return code === EAuthSocialErrorCode.FacebookAlreadyExists || code === EAuthSocialErrorCode.GoogleAlreadyExists ? code : null;
};

export const AuthHooks = { useSocialConnectError };
